import React, { useEffect, useState } from 'react';
import {
  Empty,
  Modal,
  Form,
  Input,
  Button,
  notification,
  Popconfirm,
  Pagination,
  Skeleton,
  Menu,
  Dropdown,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  addAnnouncement,
  deleteAnnouncement,
  editAnnouncement,
  getAnnouncement,
} from '@/actions/room';
import { addData, setData } from '@/actions/auth';
import moment from 'moment';
import ReadMore from '../../../../common/read-more';
import { useRouter } from 'next/router';
import AvatarComponent from '@/components/common/avatar';
import useWidth from '@/helpers/widthUtil';

const NoticeRoom = ({ dashboard, roomId, roomSlug, has_permission }) => {
  const { isMobile } = useWidth();
  const router = useRouter();
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  const dispatch = useDispatch();
  const { TextArea } = Input;

  useEffect(() => {
    clearState();
  }, []);

  const announcements = useSelector((state: any) => state.roomReducer.announcements);

  const SkeletonData = [1, 2, 3, 4];
  const [addAnnouncementModal, setAddAnnouncementModal] = useState(false);
  const [editAnnouncementModal, setEditAnnouncementModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [query, setQuery] = useState({ page: 1, per_page: 6 });
  const [submitHit, setSubmitHit] = useState(false);

  useEffect(() => {
    submitHit &&
      setTimeout(() => {
        setSubmitHit(false);
      }, 3000);
  }, [submitHit]);

  useEffect(() => {
    if (router?.query?.tab === 'announcement') {
      router?.query?.announcement
        ? dispatch(
            getAnnouncement(roomSlug, {
              ...query,
              order_by_id: router?.query?.announcement,
            })
          )
        : dispatch(getAnnouncement(roomSlug, query));
    }
  }, [router?.query, query]);

  useEffect(() => {
    if (announcements?.status && submitHit) {
      notification.success({ message: 'New Notice Has been Published' });
      setAddAnnouncementModal(false);
      form.resetFields();
      clearState();
    }
  }, [announcements?.status]);

  useEffect(() => {
    if (announcements?.updateAnnouncementInstructor === 'success' && submitHit) {
      notification.success({ message: 'Announcement Updated!' });
      setEditAnnouncementModal(false);
      clearState();
    }
  }, [announcements?.updateAnnouncementInstructor]);

  useEffect(() => {
    if (announcements?.deleteSuccess && submitHit) {
      notification.success({ message: 'Deleted Announcement!' });
      clearState();
    }
  }, [announcements?.deleteSuccess]);

  const onFinish = async (values: any) => {
    var values = {
      ...values,
      room: roomId,
    };
    dispatch(addAnnouncement(values));
    setSubmitHit(true);
  };

  const onEditFinish = async (values: any) => {
    var values = {
      ...values,
    };
    dispatch(editAnnouncement(values, editData?.id));
    setSubmitHit(true);
  };

  const PostMenu = ({ editValue }) => {
    return (
      <Menu className="p-2" style={{ borderRadius: '8px' }}>
        <Menu.Item className="pr-5 p-2" style={{ borderRadius: '8px' }}>
          <a onClick={() => handleEditClick(editValue)}>
            <div className="dropdown-media d-flex align-items-center px-2">
              <i className="fas fa-edit fa-lg text-muted mr-3"></i>
              <span className="mr-3">Edit Notice</span>
            </div>
          </a>
        </Menu.Item>
        <Menu.Item className="pr-5 p-2" style={{ borderRadius: '8px' }}>
          <Popconfirm
            title="Sure to delete?"
            onConfirm={(e) => handleDelete(editValue?.id)}
          >
            <a title="Delete Notice " className=" d-flex align-items-center px-2">
              <i className="fas fa-trash fa-lg text-muted mr-3"></i>
              <span>Delete Notice</span>
            </a>
          </Popconfirm>
        </Menu.Item>
      </Menu>
    );
  };

  const clearState = () => {
    dispatch(
      setData({
        name: 'announcements',
        key: 'updateAnnouncementInstructor',
        value: '',
      })
    );
    dispatch(
      addData({
        key: 'announcements',
        value: {},
      })
    );
    dispatch(
      setData({
        name: 'announcements',
        key: 'success',
        value: false,
      })
    );
    dispatch(
      setData({
        name: 'announcements',
        key: 'deleteSuccess',
        value: false,
      })
    );
  };

  const handleEditClick = (each: any) => {
    var aData =
      announcements.data &&
      announcements.data.length !== 0 &&
      announcements.data.find((item: any) => item.id === each.id);
    setEditData(aData);
    setEditAnnouncementModal(true);
    editForm.setFieldsValue({
      notice: aData.notice,
      title: aData.title,
    });
  };

  const handleDelete = (id: string) => {
    // e.preventDefault();
    dispatch(deleteAnnouncement(id));
    setSubmitHit(true);
  };
  const handlePagination = (page, PageSize) => {
    setQuery({ ...query, page: page, per_page: PageSize });
  };

  return (
    <>
      <Modal
        title="Publish Announcement"
        visible={addAnnouncementModal}
        footer={null}
        onCancel={() => {
          setAddAnnouncementModal(false);
        }}
        destroyOnClose
      >
        <Form form={form} onFinish={onFinish}>
          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: 'Title is required!' }]}
          >
            <Input style={{ borderRadius: '5px' }} />
          </Form.Item>
          <Form.Item
            label="Notice"
            name="notice"
            rules={[{ required: true, message: 'Notice is required!' }]}
          >
            <TextArea rows={8} style={{ borderRadius: '5px' }} />
          </Form.Item>
          <div className="d-flex align-items-center  justify-content-end">
            <Button
              className="border-0 px-4"
              onClick={() => {
                setAddAnnouncementModal(false);
              }}
              style={{ boxShadow: 'unset', color: '#283360' }}
            >
              Cancel
            </Button>
            <Form.Item className="mb-0">
              <Button
                type="primary"
                className="px-5"
                htmlType="submit"
                style={{ borderRadius: '5px' }}
                loading={announcements?.status === false}
              >
                Submit
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>
      <Modal
        title="Edit Announcement"
        visible={editAnnouncementModal}
        footer={null}
        onCancel={() => setEditAnnouncementModal(false)}
      >
        <Form form={editForm} onFinish={onEditFinish}>
          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: 'Title is required!' }]}
          >
            <Input style={{ borderRadius: '5px' }} />
          </Form.Item>
          <Form.Item
            label="Notice"
            name="notice"
            rules={[{ required: true, message: 'Notice is required!' }]}
          >
            <TextArea rows={8} style={{ borderRadius: '5px' }} />
          </Form.Item>
          <div className="d-flex align-items-center  justify-content-end">
            <Button
              className="border-0 px-4"
              onClick={() => setEditAnnouncementModal(false)}
              style={{ boxShadow: 'unset', color: '#283360' }}
            >
              Cancel
            </Button>
            <Form.Item className="mb-0">
              <Button
                type="primary"
                className="px-5"
                htmlType="submit"
                style={{ borderRadius: '5px' }}
                loading={announcements?.updateAnnouncementInstructor === 'request'}
              >
                Submit
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>
      <div
        className={`col-md-9 col-lg-12 d-flex flex-wrap align-items-center justify-content-end ${
          isMobile && 'px-0'
        }`}
      >
        {has_permission && (
          <Button
            type="primary"
            className="rounded-lg"
            onClick={() => setAddAnnouncementModal(true)}
          >
            Add Annoucement
            <span className="add-btn ml-2">
              <i className="fas fa-plus"></i>
            </span>
          </Button>
        )}
      </div>
      <div
        className={`col-lg-12 d-flex ${
          isMobile && 'flex-column px-0'
        } gap-3 mt-3 w-100`}
        style={{ flexWrap: 'wrap' }}
      >
        {announcements?.loading ? (
          SkeletonData.map((index: number) => <Skeleton key={index} />)
        ) : announcements?.data && announcements?.data?.length !== 0 ? (
          announcements?.data?.map((each, i: number) => (
            <div
              className="py-4 px-3 bg-white rounded-lg w-100"
              style={{
                boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                flexBasis: '48.8%',
              }}
              key={i}
            >
              <div className="d-flex justify-content-between">
                <h5
                  className="font-weight-normal m-0 "
                  style={{ maxHeight: '80px' }}
                >
                  {each?.title}
                </h5>
                {has_permission ? (
                  <div
                    className="d-flex list-action"
                    style={{ height: 'fit-content' }}
                  >
                    <Dropdown
                      overlay={<PostMenu editValue={each} />}
                      placement="bottomLeft"
                      className="dropdown-ml ml-auto"
                      trigger={['click']}
                      overlayStyle={{ minWidth: '160px' }}
                    >
                      <div>
                        <a className="badge bg-warning-light">
                          <i className="fas fa-ellipsis-h"></i>
                        </a>
                      </div>
                    </Dropdown>
                  </div>
                ) : (
                  ''
                )}
              </div>

              <div className=" py-3 flex-grow-1 ">
                <ReadMore className="text-justify" text={each?.notice} />
              </div>
              <div className="d-flex align-items-center  gap-2 ">
                <AvatarComponent
                  size={36}
                  firstName={each.created_by.first_name}
                  lastName={each.created_by.last_name}
                  avatar={each.created_by.avatar}
                />
                <div style={{ lineHeight: '1.4' }}>
                  <span
                    className="user-name"
                    style={{ fontWeight: '600', color: '#000' }}
                  >
                    {each.created_by.first_name} {each.created_by.last_name}
                  </span>
                  <div>
                    <span className="text-muted d-time d-block">
                      {moment(each.created_at).fromNow()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <Empty className="" description="No Announcements for this Room" />
        )}
      </div>
      {announcements?.data?.length !== 0 && (
        <div className="d-flex justify-content-end ">
          <Pagination
            className="my-3 pl-4"
            total={announcements?.meta?.total}
            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
            defaultPageSize={query?.per_page}
            defaultCurrent={query?.page}
            onChange={handlePagination}
          />
        </div>
      )}
    </>
  );
};

export default NoticeRoom;
